import TooltipInfo from 'approot/shared/tooltip/tooltip-info';
import * as Styled from './badge-activity-media-type.style';
import {
  ACTIVITIES_BADGE_PROPERTIES,
  PDF_BADGE_PROPERTIES,
} from './badge-activity-media-type.constants';
import {
  BadgeSmallStyled,
  BadgeStyled,
} from 'approot/shared/badge/badge.style';
import { grey1, purple7 } from 'approot/shared/styles/colours.style';

const BadgeDigitalSlides = ({
  isSmall,
  showTooltip,
}: {
  isSmall?: boolean;
  showTooltip?: boolean;
}) => {
  const badgeProperties = ACTIVITIES_BADGE_PROPERTIES;
  const { label, tooltipText } = badgeProperties;

  const toolTip = showTooltip ? (
    <TooltipInfo hoverText={tooltipText} multiline />
  ) : null;

  return (
    <Styled.BadgeActivityMediaTypeWrapper $colour={grey1}>
      {isSmall ? (
        <BadgeSmallStyled $colour={purple7}>
          {label}
          {toolTip}
        </BadgeSmallStyled>
      ) : (
        <BadgeStyled $colour={purple7}>
          {label}
          {toolTip}
        </BadgeStyled>
      )}
    </Styled.BadgeActivityMediaTypeWrapper>
  );
};

const BadgePDF = ({
  isSmall,
  showTooltip,
}: {
  isSmall?: boolean;
  showTooltip?: boolean;
}) => {
  const badgeProperties = PDF_BADGE_PROPERTIES;
  const { label, tooltipText } = badgeProperties;

  const toolTip = showTooltip ? (
    <TooltipInfo hoverText={tooltipText} multiline />
  ) : null;

  return (
    <Styled.BadgeActivityMediaTypeWrapper>
      {isSmall ? (
        <BadgeSmallStyled>
          {label}
          {toolTip}
        </BadgeSmallStyled>
      ) : (
        <BadgeStyled>
          {label}
          {toolTip}
        </BadgeStyled>
      )}
    </Styled.BadgeActivityMediaTypeWrapper>
  );
};

const BadgeActivityMediaType = ({
  hasActivities,
  isSmall,
  showTooltip,
}: {
  hasActivities?: boolean;
  isSmall?: boolean;
  showTooltip?: boolean;
}) => {
  return hasActivities ? (
    <BadgeDigitalSlides isSmall={isSmall} showTooltip={showTooltip} />
  ) : (
    <BadgePDF isSmall={isSmall} showTooltip={showTooltip} />
  );
};
export default BadgeActivityMediaType;
